<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('grant_registration.prepare_notice')}}</h4>
      </template>
      <template v-slot:body>
        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
            <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                <b-row>
                  <b-col xl="6" lg="6" sm="12">
                      <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                          <b-form-group
                              class="row"
                              label-cols-sm="3"
                              label-for="fiscal_year_id"
                              slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                              {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                          </template>
                          <b-form-select
                              plain
                              v-model="search.fiscal_year_id"
                              :options="fiscalYearList"
                              id="fiscal_year_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                          >
                          <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                          </b-form-select>
                          <div class="invalid-feedback">
                              {{ errors[0] }}
                          </div>
                          </b-form-group>
                      </ValidationProvider>
                  </b-col>
                    <b-col sm="12" md="6" lg="6" xl="6">
                    <b-form-group
                    class="row"
                    label-cols-md="12"
                    label-cols-lg="3"
                      :label="$t('grant_budget_management.organization')"
                      label-for="org_id"
                    >
                      <b-form-select
                        plain
                        v-model="search.org_id"
                        :options="organizationList"
                        id="org_id"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" lg="6" xl="6">
                    <b-form-group
                    class="row"
                    label-cols-md="12"
                    label-cols-lg="3"
                    :label="$t('grant_config.service_type')"
                    label-for="service_type_list"
                    >
                      <b-form-select
                        plain
                        v-model="search.service_type_id"
                        :options="serviceTypeList"
                        id="service_type_list"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" lg="6" xl="6">
                      <b-form-group
                      class="row"
                      label-cols-md="12"
                    label-cols-lg="3"
                      :label="$t('grant_config.service_name')"
                      label-for="service_list"
                      >
                        <b-form-select
                          plain
                          v-model="search.service_id"
                          :options="serviceList"
                          id="service_list"
                          >
                          <template v-slot:first>
                          <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                  </b-col>
                  <b-col sm="12" md="6" lg="6" xl="6">
                      <b-form-group
                      class="row"
                      label-cols-md="12"
                    label-cols-lg="3"
                      :label="$t('grant_registration.notice_status')"
                      label-for="notice_status"
                      >
                        <b-form-select
                          plain
                          v-model="search.status"
                          :options="getNoticeStatusList"
                          id="notice_status"
                          >
                          <template v-slot:first>
                          <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                  </b-col>
                  <b-col sm="12" lg="6">
                      <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                  </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
      </template>
    </iq-card>
    <!-- /Search Form -->

    <!-- Table/List -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('grant_registration.prepare_notice') + ' ' + $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
              <i class="fas fa-plus"></i>{{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                     <template v-slot:cell(status)="data">
                        <span class="badge badge-warning" v-if="data.item.status == 1">{{$t('globalTrans.pending')}}</span>
                        <span class="badge badge-success" v-else-if="data.item.status == 2">{{$t('grant_registration.circulated')}}</span>
                        <span class="badge badge-success" v-else-if="data.item.status == 3">{{$t('globalTrans.approved')}}</span>
                        <span class="badge badge-danger" v-else>{{$t('globalTrans.rejected')}}</span>
                    </template>
                   <template v-slot:cell(action)="data">
                        <a href="javascript:" class="btn_table_action btn_green" title="View Details" v-b-modal.modal-2 @click="view(data.item)"><i class="ri-eye-fill m-0"></i></a>
                        <a href="javascript:" class="btn_table_action btn_blue" title="Modify" v-if="!data.item.is_send" v-b-modal.modal-4 @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></a>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- Table/List -->
    <b-modal id="modal-4" size="xl" :title="formTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Form :id="editItemId" :key="editItemId"/>
    </b-modal>
    <b-modal id="modal-2" size="lg" :title="ViewTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :id="editItemId" :key="editItemId"/>
    </b-modal>
  </b-container>
</template>
<script>
import Details from './Details'
import Form from './Form'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { noticeListApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import moment from 'moment'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Details,
    Form,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      editItemId: 0,
      search: {
          service_type_id: 0,
          service_id: 0,
          org_id: 0,
          fiscal_year_id: 0,
          status: 0
      },
      url: grantAllowanceServiceBaseUrl,
      serviceList: [],
      rows: []
    }
  },
  computed: {
    getNoticeStatusList: function () {
        return this.$store.state.GrantAllowanceService.commonObj.noticeStatusList.map((item) => {
          return { value: item.value, text: this.$i18n.locale === 'en' ? item.text_en : item.text_bn }
        })
    },
     serviceTypeList: function () {
        const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    formTitle () {
      return (this.editItemId === 0) ? this.$t('grant_registration.prepare_notice') + ' ' + this.$t('globalTrans.entry') : this.$t('grant_registration.prepare_notice')
    },
    ViewTitle () {
       return (this.$t('grant_registration.prepare_notice'))
    },
    organizationList () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
   },
   fiscalYearList: function () {
   return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
   },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
          { label: this.$t('globalTrans.organization'), class: 'text-left' },
          { label: this.$t('grant_config.service_type'), class: 'text-left' },
          { label: this.$t('grant_config.service_name'), class: 'text-left' },
          { label: this.$t('grant_registration.notice_title'), class: 'text-left' },
          { label: this.$t('grant_registration.created'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'org_name_bn' },
          { key: 'service_type_bn' },
          { key: 'service_name_bn' },
          { key: 'notice_bn' },
          { key: 'created_time' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
          { key: 'index' },
          { key: 'org_name' },
          { key: 'service_type' },
          { key: 'service_name' },
          { key: 'notice' },
          { key: 'created_time' },
          { key: 'status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
      })
    }
  },
  watch: {
    'search.service_type_id': function (newVal, oldVal) {
      this.getServiceList()
    },
    currentLocale: function (newVal, oldVal) {
      if (this.search.service_type_id) {
          this.getServiceList()
      }
    }
  },
  created () {
        this.loadData()
  },
  mounted () {
  },
  methods: {
    searchData () {
      this.loadData()
    },
    edit (item) {
      this.editItemId = item.id
    },
    view (item) {
      this.editItemId = item.id
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(grantAllowanceServiceBaseUrl, noticeListApi, params).then(response => {
            if (response.success) {
                this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                this.paginationData(response.data)
            }
            this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
     getRelationalData (data) {
          const listData = data.map(item => {
          const tmpOrg = this.$store.state.orgList.find(org => org.status === 0 && org.value === item.org_id)
          const tmpServiceType = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList.find(service => service.value === item.service_type_id)
          const tmpServiceName = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.find(service => service.status === 0 && service.value === item.service_id)
          const tmpFiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscalYear => fiscalYear.status === 0 && fiscalYear.value === item.fiscal_year_id)
          const tmpCreatedTime = moment(item.created_at).startOf('minute').fromNow()

          const newData = {
              org_name: tmpOrg !== undefined ? tmpOrg.text_en : '',
              org_name_bn: tmpOrg !== undefined ? tmpOrg.text_bn : '',
              service_type: tmpServiceType !== undefined ? tmpServiceType.text_en : '',
              service_type_bn: tmpServiceType !== undefined ? tmpServiceType.text_bn : '',
              service_name: tmpServiceName !== undefined ? tmpServiceName.text_en : '',
              service_name_bn: tmpServiceName !== undefined ? tmpServiceName.text_bn : '',
              fiscal_name: tmpFiscalYear !== undefined ? tmpFiscalYear.text_en : '',
              fiscal_name_bn: tmpFiscalYear !== undefined ? tmpFiscalYear.text_bn : '',
              created_time: tmpCreatedTime !== undefined ? tmpCreatedTime : ''
          }
          return Object.assign({}, item, newData)
        })
        return listData
      },
      getServiceList () {
        this.serviceList = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.filter(item => item.status === 0 && item.service_type_id === this.search.service_type_id && item.has_public_form === 1).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
      }
  }
}
</script>
